<template>
  <div
    class="panel-container w-full md:mx-2 md:overflow-y-scroll md:rounded shadow bg-white py-5 px-3 md:px-10"
  >
    <div v-if="getCurrentApplication">
      <div class="flex flex-col py-4">
        <!-- START Documents List -->
        <div class="flex flex-col" v-if="getCurrentApplication.documents.length">
          <h2 class="">Documents</h2>
          <div class="flex flex-col my-3">
            <div
              class="flex flex-col justify-between"
              v-for="(doc, index) in getCurrentApplication.documents"
              :key="index"
            >
              <div class="flex items-center">
                <div class="flex flex-col w-1/2 py-1 px-1">
                  <h5 class="font-semibold">
                    {{ doc.template.name }} -
                    <template v-if="doc.status === 'completed'">
                      <span class="text-brand-green font-normal">Completed</span>
                    </template>
                    <template v-if="doc.status === 'started'">
                      <span class="text-brand-blue font-normal">Started</span>
                    </template>
                    <template v-if="doc.status === 'sent'">
                      <span class="text-brand-yellow font-normal">Sent</span>
                    </template>
                  </h5>
                  <p class="text-xs text-brand-gray">{{ formatActivity(doc.modified) }}</p>
                  <p class="py-1 text-xs">
                    <span class="font-semibold">Sent to</span>:
                    {{ doc.sent_to.map((s) => s.name).join(", ") }}
                  </p>
                </div>

                <div
                  class="flex justify-end items-center w-1/2 py-1 px-1"
                  v-if="doc.status === 'completed'"
                >
                  <router-link
                    :to="{ name: 'dashboard_signing_view', params: { id: doc.id } }"
                    class="text-brand-green"
                  >
                    View document
                  </router-link>
                </div>
              </div>
              <div class="border-t border-brand-mid-gray my-2 w-full"></div>
            </div>
          </div>
        </div>
        <!-- END Documents List -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

import moment from "moment"

import {} from "@heroicons/vue/outline"

export default {
  computed: {
    ...mapGetters(["getCurrentApplication"])
  },
  components: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {
    formatActivity(date) {
      return moment(date).fromNow()
    }
  }
}
</script>
<style lang="scss" scoped>
.panel-container {
  min-height: 50vh;
  height: 100%;
}
@screen md {
  .panel-container {
    height: 700px;
  }
}
</style>
